import { render, staticRenderFns } from "./OverviewPage.vue?vue&type=template&id=4f9b7639&scoped=true&"
import script from "./OverviewPage.vue?vue&type=script&lang=js&"
export * from "./OverviewPage.vue?vue&type=script&lang=js&"
import style0 from "./OverviewPage.vue?vue&type=style&index=0&id=4f9b7639&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9b7639",
  null
  
)

export default component.exports